import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralLedgerReportAccount  {
    _originalTypeClassName = "zERP.BO.GeneralLedgerReportAccount";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralLedgerReportAccount.translate = translateService;
}
this.Id = null;
this.Code = null;
this.Description = null;
this.PrevDebit = null;
this.PrevCredit = null;
this.CurrentDebit = null;
this.CurrentCredit = null;
this.PrevBalanceDebit = null;
this.PrevBalanceCredit = null;
this.BalanceDebit = null;
this.BalanceCredit = null;
this.CurrentCreditSum = null;
this.CurrentDebitSum = null;
this.BalanceCreditSum = null;
this.BalanceDebitSum = null;
this.GeneralLedgerReportAccountKey = null;
this._key = this.GeneralLedgerReportAccountKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Code:any;
Description:any;
PrevDebit:any;
PrevCredit:any;
CurrentDebit:any;
CurrentCredit:any;
PrevBalanceDebit:any;
PrevBalanceCredit:any;
BalanceDebit:any;
BalanceCredit:any;
CurrentCreditSum:any;
CurrentDebitSum:any;
BalanceCreditSum:any;
BalanceDebitSum:any;
private _GeneralLedgerReportAccountKey:any;
get GeneralLedgerReportAccountKey(): any {
    return this._GeneralLedgerReportAccountKey;
  }
set GeneralLedgerReportAccountKey(value: any) {
    this._GeneralLedgerReportAccountKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GeneralLedgerReportAccountKey == null || $this.GeneralLedgerReportAccountKey == 0;
            }


}